<template>
    <div class="llp-number">
        <span>{{ number }}</span>
    </div>
</template>

<script>
import {formatNumber} from '../../services/formatNumber.service';

export default {
  name: 'llp-number',
  props: {
    value: {
      type: Number,
    },
  },
  methods: {
    formatNumber,
  },
  computed: {
    number() {
      return this.formatNumber(this.value);
    },
  },
};
</script>
